import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./InfoBoxes.css";

const InfoBoxes = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialize AOS with a 1-second animation duration
  }, []);

  return (
    <div className="info-boxes-container">
      <div
        className="info-box first-box"
        data-aos="fade-up"
      >
        <h3>100% Money Back Guarantee</h3>
        <p
        data-aos="fade-right"
        data-aos-delay="200" 
        >
          Don’t like our product? Just let us know and we will replace the
          products or refund you in full. Terms and conditions apply.
        </p>
        <img src="/images/coin.png" alt="Money Back Guarantee" />
      </div>

      <div
        className="info-box second-box"
        data-aos="fade-up"
      >
        <h3>Over 4,000 Print Ready Templates</h3>
        <p
        data-aos="fade-left"
        data-aos-delay="200" 
        >
          Select from a wide range of creative design templates. Simply edit
          and you’re done.
        </p>
        <img src="/images/pr.png" alt="Print Ready Templates" />
      </div>
    </div>
  );
};

export default InfoBoxes;
